import { FC } from "react";
import Link from "../../common/Link";
import Table from "../../common/Table";
import { matchesColumns, matchesMobileColumns } from "../../config/Tables/match";
import { getAuth } from "../../services/AuthService";
import { TodayMatch } from "../../helpers/interfaces/category";
import { useMenuSingleton } from '../../singleton/menuSingleton';

interface ICategoryGroupMatchesTable {
    category: TodayMatch,
    group: string,
    groupId: string,
    currentCategory: TodayMatch | undefined,
    matchesCategory: { [key: string]: any }[]
}

const CategoryGroupMatchesTable: FC<ICategoryGroupMatchesTable> = (
    { category, matchesCategory, currentCategory, group, groupId }
) => {

    const auth = getAuth();
    const { getMenu, getSlugPath } = useMenuSingleton();
    const slugPath = getSlugPath(getMenu().data);

    return <>
        <h3 className="text-center mt-3 group-title display-6 display-lg-4">{category.nomeCategoria} - {group}</h3>
        <Table
            id={`tab_matches_categories_table_${category.idCategoria}_${group}`}
            columns={auth ? [...matchesColumns] : [...matchesColumns.slice(0, -1)]}
            columnsMobile={auth ? [...matchesMobileColumns] : [...matchesMobileColumns.slice(0, -1)]}
            data={matchesCategory}
            emptyDataText="Nessuna partita odierna presente"
        />
        <div id="tab_partite_odierne_caption" className='d-flex flex-wrap fs-7 ms-2'>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle rinviata" aria-hidden="true" /> = Rinviata
            </div>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle in-corso" aria-hidden="true" /> = In corso
            </div>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle sospesa" aria-hidden="true" /> = Sospesa
            </div>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle terminata" aria-hidden="true" /> = Terminata
            </div>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle-o da-giocare" aria-hidden="true" /> = Da giocare
            </div>
        </div>
        <div id="ranking-link" className="text-end mt-2">
            <Link
                href={slugPath["_competizioni_" + category.idCategoria]}
                state={{ categoryName: category.nomeCategoria, categoryId: category.idCategoria, groupId }}
                title="Vai alla classifica"
            >
                Vai alla classifica
            </Link>
        </div>
    </>
}

export default CategoryGroupMatchesTable;